import { useState, useEffect, useRef } from 'react';
import SwiperCore, { Swiper, Scrollbar } from 'swiper';
import 'swiper/swiper-bundle.min.css';
import 'swiper/swiper.min.css';
import './style.scss';

SwiperCore.use([Scrollbar]);

import { contentSection, dataSlide, titleContent, ILocation } from 'data/location';
import SidebarScroll, { Element } from '../../SidebarScroll';
import { GetGeocode } from 'common-modules/general/Modules/functions';

import pinMain from 'assets/common/ico_pin03.png';
import pinSub from 'assets/common/ico_pin05.png';
import ImgPopup from '../../ImgPopup';

import developmentPlan01 from 'assets/Desktop/images/parcelOut/dev01.jpg';
import developmentPlan02 from 'assets/Desktop/images/parcelOut/dev02.jpg';
import developmentPlan03 from 'assets/Desktop/images/parcelOut/dev03.jpg';

const Location = () => {
  // modal ref
  const imgModalRef = useRef<any>();
  const modalRef = useRef<any>();

  const [selectedAddress, setSelectedAddress] = useState<ILocation>({
    img: '',
    title: '현장',
    address: '충청북도 옥천군 옥천읍 동안리 15-1번지'
  });

  useEffect(() => {
    const fetchData = async () => {
      try {
        // #1. 네이버맵을 위한 좌표 변환
        const address_1: string = selectedAddress.address;
        const item: naver.maps.Service.AddressItemV2 = await GetGeocode(address_1);
        const fixItem: naver.maps.Service.AddressItemV2 = await GetGeocode('충청북도 옥천군 옥천읍 동안리 15-1번지');

        // 네이버맵 가동 (현장위치)
        const location_1_map: naver.maps.Map = new naver.maps.Map('location_1', {
          center: new naver.maps.LatLng(Number(item.y), Number(item.x)),
          zoom: 17, // 지도의 초기 줌 레벨
          minZoom: 13, // 지도의 최소 줌 레벨
          maxZoom: 18, // 지도의 최대 줌 레벨
          zoomControl: true, // 줌 컨트롤의 표시 여부
          mapTypeControl: true
        });

        // 네이버맵 보조 마커 표시 (현장위치)
        const promises: Promise<void>[] = dataSlide.map((value: any) => {
          return new Promise<void>(async (resolve, reject) => {
            try {
              const _i: naver.maps.Service.AddressItemV2 = await GetGeocode(value.address);

              if (value.address !== selectedAddress.address) {
                new naver.maps.Marker({
                  title: value.title,
                  position: new naver.maps.LatLng(Number(_i.y), Number(_i.x)),
                  map: location_1_map,
                  icon: pinSub
                });
              }

              resolve();
            } catch {
              resolve();
            }
          });
        });

        await Promise.all(promises);

        if (selectedAddress.title !== '현장') {
          // 네이버맵 마커 표시 (현장위치)
          new naver.maps.Marker({
            title: selectedAddress.title,
            position: new naver.maps.LatLng(Number(item.y), Number(item.x)),
            map: location_1_map,
            icon: {
              content: `     <div class='pin'>
        <span class='pin-container'>
          <span class='pin-img'><img src=${pinMain} alt=${selectedAddress.title} /></span>
          <span class='pin-title' >${selectedAddress.title}</span>
        </span>
      </div>
        `
            }
          });
        }

        new naver.maps.Marker({
          title: '현장',
          position: new naver.maps.LatLng(Number(fixItem.y), Number(fixItem.x)),
          map: location_1_map,
          icon: {
            content: `     <div class='pin'>
              <span class='pin-container'>
                <span class='pin-point' style="z-index: 1;"></span>
                <span class='pin-title' style="z-index: 1;">현장</span>
              </span>
            </div>
              `,
            size: new naver.maps.Size(38, 58)
          }
        });
      } catch (e) {}
    };

    fetchData();
  }, [selectedAddress]);

  useEffect(() => {
    initSwiper();
  }, []);

  const sidebarList = [
    { name: '특징', isActive: true},
    { name: '주변시설', isActive: true},
    { name: '개발 계획', isActive: true}
  ];

  const handleClickMap = (sp: ILocation) => {
    setSelectedAddress(sp);
  };

  const [isImgPopupOpen, setIsImgPopupOpen] = useState(false);
  const [popupImg, setPopupImg] = useState('');
  const [popupTitle, setPopupTitle] = useState('');

  const handleClickImg = (img: string, title: string) => {
    setIsImgPopupOpen(true);
    setPopupImg(img);
    setPopupTitle(title);
  };

  const initSwiper = () => {
    new Swiper('#swiperWrap', {
      scrollbar: {
        el: '.swiper-scrollbar',
        draggable: true
      },
      navigation: {
        prevEl: '.swiper-button-prev-child',
        nextEl: '.swiper-button-next-child',
        disabledClass: 'swiper-button-disabled'
      },
      mousewheel: true,
      slidesPerView: 3,
      spaceBetween: 20
    });
  };

  return (
    <div className="contents-location">
      <div className="content" id="content">
        <SidebarScroll sidebarList={sidebarList} />

        <div className="content-container">
          {/* 특징 */}
          {sidebarList[0].isActive ? (
            <Element name={sidebarList[0].name}>
              <div id="infoMap" className="infoMap">
                <div className="infoMap-icon">
                  <div className="icon"></div>
                </div>
                <div className="infoMap-title">{titleContent.tit}</div>
                {/* <div className="infoMap-detail">{titleContent.desc}</div> */}
                <div className="infoMap-img">
                  <img
                    onClick={() => {
                      handleClickImg(titleContent.PositionImgBig, '광역 위치도');
                    }}
                    src={titleContent.PositionImg}
                    alt=""
                  />
                </div>
                <div className="infoMap-img-caution-text">
                  <p>{titleContent.infoMap}</p>
                  <p>{titleContent.infoMap2}</p>
                </div>

                {/* 홍보문구 */}
                <div className="infoMap-content">
                  {contentSection.map((value, idx) => {
                    return (
                      <div className="infoMap-content-items" key={idx}>
                        <div className="title">{value.tit}</div>
                        <ul className="list-items">
                          {value.desc.map((val, innerIdx) => (
                            <li key={innerIdx}>{val}</li>
                          ))}
                        </ul>
                      </div>
                    );
                  })}
                </div>

                {/* <div className="infoMap-img">
                  <img
                    onClick={() => {
                      handleClickImg(titleContent.wideBirdsView, '광역 조감도');
                    }}
                    src={titleContent.wideBirdsView}
                    alt=""
                  />
                </div> */}
              </div>
            </Element>
          ) : null}

          {/* 주변시설 start  */}
          {sidebarList[1].isActive ? (
            <Element name={sidebarList[1].name}>
              <div id="sliceLocation" className="slideLocation">
                <h3>주변시설</h3>
                <h4>최고의 입지</h4>
                <p className="slideLocation-detail">교통, 병원, 생활 편의 시설까지 완벽한 입지를 누린다.</p>
                <div className="slideLocation-img">
                  <div id="location_1" style={{ width: '100%', height: '100%' }}></div>
                </div>
                <div style={{ overflow: 'hidden' }} id="swiperWrap">
                  <div className="swiper-wrapper">
                    {dataSlide.map((sp, index) => {
                      return (
                        <div key={sp.title} onClick={() => handleClickMap(sp)} className={'swiper-slide'}>
                          <div className="main-items-img">
                            <img src={sp.img} alt="" />
                          </div>
                          <div className="main-items-content">{sp.title}</div>
                        </div>
                      );
                    })}
                  </div>

                  <div className="swiper-footer-content-container">
                    <div className="swiper-scrollbar-container">
                      <div className="swiper-scrollbar"></div>
                    </div>

                    <div className="swiper-button-container">
                      <button className={'swiper-button-prev-child'}></button>
                      <button className={'swiper-button-next-child'}></button>
                    </div>
                  </div>
                </div>

                <div className="slideLocation-notice">* 본 사진은 2022년 09월에 촬영된 사진입니다.</div>
              </div>
            </Element>
          ) : null}

          {/* 개발계획  */}
          {sidebarList[2].isActive ? (
            <Element name={sidebarList[2].name}>
              <div id="infoHouse" className="infoHouse">
                <h3>개발계획</h3>
                {/* <div className="infoHouse-subTitle">대전도시철도 2호선 트램 “기본계획 변경” 추진</div>
                <div className="infoHouse-content">
                  <div className="infoHouse-content-left">
                    <div className="content-detail">
                      <div className="content-detail-items">
                        <p className='content-detail-items__tit'>대전역 경유, 정거장 추가 등 기본설계 반영 따른 총사업비, 사업기간 조정</p>

                        <div className='content-detail-items__list'>
                          <h3>[기본계획 변경사유]</h3>
                          <ul>
                            <li>① 기본설계 결과 반영한 총사업비 조정</li>
                            <li>② 대전역 경유 등 노선 확정(36.6㎞ → 38.1㎞ / 증 1.5㎞)</li>
                            <li>③ 접근편의성, 이용수요 고려한 정거장 확충<br/>(35개소 → 45개소) / 증 10개소</li>
                            <li>④ 사업기간 현실화(개통 2027년 → 2028년 / 증 1년)</li>
                          </ul>
                          <span>※ 근거 : 도시철도법 제6조</span>
                        </div>

                        <div className='content-detail-items__list'>
                          <h3>[총사업지 조정현황]</h3>
                          <p>
                            * 총사업지 조정 사유<br/>
                            당초 예비타당성조사 운용지침에 따라 개략적인 사업비를 계상하였으나, 정확한 현장조사 및 기술여건, 운행안전성 확보, 이용 편의성 등을 위해 총사업비 증가
                          </p>
                          <span>※ 근거 : 총사업비관리지침 제49조의2</span>
                        </div>

                        <div className='content-detail-items__list'>
                          <h3>[향후 일정]</h3>
                          <ul className='desc'>
                            <li>기본계획 변경 및 총사업비 조정(2023. 上)</li>
                            <li>실시설계 및 사업계획 승인(2023. 下)</li>
                            <li>공사 추진 및 개통(2024. ~ 2028.)</li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="infoHouse-content-right">
                    <img
                      src={developmentPlan01}
                      alt=""
                      onClick={() => {
                        handleClickImg(developmentPlan01, '개발 계획');
                      }}
                    />
                  </div>
                </div> */}

                <div className="infoHouse-subTitle">대전-옥천 광역철도</div>
                <div className="infoHouse-content">
                  <div className="infoHouse-content-left">
                    <div className="content-detail">
                      <div className="content-detail-items">
                        {/* <p className='content-detail-items__tit'>
                          홍제역 주변을 자족ㆍ고품격ㆍ친환경을 주요테마로 서북권 전역의<br />
                          지역특화거점으로 조성
                        </p> */}
                      </div>
                      {/* <div className='content-detail-items__list'>
                          <p className='cate'>[개요]</p>
                          <ul className='desc'>
                            <li>사업구간 : 오정 ~ 옥천 /. 20.1km</li>
                            <li>사업기간 2021년 ~ 2026년</li>
                            <li>총사업비 : 490억원</li>
                            <li>사업내용 : 정거장 4개소(오정,대전,세천,옥천), 기존선 활용</li>
                          </ul>
                      </div> */}
                      <div className="content-detail-items">
                        <p className='cate'>[개요]</p>
                        <span className="title">사업구간</span>
                        <span className="detail">오정 ~ 옥천 /. 20.1km</span>
                      </div>
                      <div className="content-detail-items">
                        <span className="title">사업기간</span>
                        <span className="detail">2021년 ~ 2026년</span>
                      </div>
                      <div className="content-detail-items">
                        <span className="title">총사업비</span>
                        <span className="detail">490억원</span>
                      </div>
                      <div className="content-detail-items">
                        <span className="title">사업내용</span>
                        <span className="detail">정거장 4개소(오정,대전,세천,옥천), 기존선 활용</span>
                      </div>
                      <div className="content-detail-items">
                        <div className='content-detail-items__list'>
                          <h3>추진사항</h3>
                          <ul className='desc'>
                            <li>제3차 국가철도망구축계획고시(’16.12.)</li>
                            <li>사전타당성조사(’16.12.)</li>
                            <li>기본계획용역 착수(‘20.2.)</li>
                            <li>기본계획용역 준공(‘20.12.)</li>
                            <li>제4차 국가철도망 구축계획 고시(’21.7.)</li>
                            <li>기본계획고시(’21.10.)</li>
                            <li>기본 및 실시설계 착수(22.4.)</li>
                          </ul>
                        </div>

                        <div className='content-detail-items__list'>
                          <h3>향후 추진방향</h3>
                          <ul className='desc'>
                            <li>기본 및 실시설계 완료(‘23.8.)</li>
                            <li>공사착공 예정(‘24.4)</li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="infoHouse-content-right">
                    <img
                      src={developmentPlan03}
                      alt=""
                      onClick={() => {
                        handleClickImg(developmentPlan03, '개발 계획');
                      }}
                    />
                  </div>
                </div>
                <div className="infoHouse-notice">
                  <p>* 참고자료 : 옥천군청 홈페이지(https://www.daejeon.go.kr/djTram/contentView.do?menuSeq=6721)</p>
                  <p>* 상기개발계획은 사업주체, 국가기관, 지자체 및 기타기관의 사업추진 중 변경, 지연, 취소될 수 있습니다.</p>
                </div>
              </div>
            </Element>
          ) : null}
          </div>
      </div>

      <ImgPopup title={popupTitle} img={popupImg} open={isImgPopupOpen} setOpen={setIsImgPopupOpen} />
    </div>
  );
};

export default Location;
